import { render } from "./pc_top.vue?vue&type=template&id=96164a42&scoped=true"
import script from "./pc_top.vue?vue&type=script&lang=js"
export * from "./pc_top.vue?vue&type=script&lang=js"

import "./pc_top.vue?vue&type=style&index=0&id=96164a42&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96164a42"]])

export default __exports__